import React, {useRef} from 'react';
import styled from 'styled-components';

import ReactPlayer from 'react-player'

import { onlineDemoIcon, videoIcon }from '../../Config/cardConfig.js'

import { Button, ButtonIcon } from './CardButtonStyle'

import smartManufacturingConfig from '../../data/smartManufacturing.js'
import { colorPalette } from '../../Config/colorConfig';

const Img = styled.img`
    position:relative;
    width:90%;
    height:auto;
`

const ImgsAndButtonsWrapper = styled.div`
    width:70%;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    padding-bottom:40px;
    @media (max-width: 1300px) {
        flex-direction:column;
    }
`

const ImgAndButtonWrapper = styled.div`
    position:relative;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    margin:0.5rem;
`

const SmallImg = styled.img`
    position:relative;
    height:auto;
    width:15vw;
    max-width:350px;
    min-width:200px;
    display:block;
`

const GoBackAndBtnWrapper= styled.div`
    position:relative;
    width:100%;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
`

const GoBackBtn = styled.div`
    position:relative;
    color:${colorPalette.myBlue};
    font-weight: 700;
`

const ButtonWrapper = styled.div`
    position:relative;
    width:30%;
    display:flex;
    flex-direction:row;
    @media (max-width: 1300px) {
        flex-direction:row;
        width:40%;
    }
    @media (max-width: 1000px) {
        width:50%;
    }
    @media (max-width: 768px) {
        flex-direction:column;
        width:40%;
    }
`

const SMObjectives=(props)=>{
    
    const{contentRef,langCh,cardContent,setCardContent,onPlay,setOnPlay}=props
    
    const playerRef = useRef(null)

    return(
    <>
        <Img 
            style={{width:'90%',marginBottom:'1rem'}}
            src={smartManufacturingConfig[cardContent][langCh?'ch':'en'].img}
        />
        <ImgsAndButtonsWrapper>
            <ImgAndButtonWrapper>
                <SmallImg
                    src={smartManufacturingConfig[cardContent][langCh?'ch':'en'].smallImg[0]}
                />
                <Button onClick={()=>setCardContent('SMSmartAutomation')}>
                    {langCh? '智慧自動化' : 'Smart Automation'}
                </Button>
            </ImgAndButtonWrapper>
            <ImgAndButtonWrapper>
                <SmallImg src={smartManufacturingConfig[cardContent][langCh?'ch':'en'].smallImg[1]}/>
                <Button onClick={()=>setCardContent('SMSmartMachines')}>
                    {langCh? '智慧設備' : 'Smart Machines'}
                </Button>
            </ImgAndButtonWrapper>
            <ImgAndButtonWrapper>
                <SmallImg src={smartManufacturingConfig[cardContent][langCh?'ch':'en'].smallImg[2]}/>
                <Button onClick={()=>setCardContent('SMSmartManagement')}>
                    {langCh? '智慧管理' : 'Smart Management'}
                </Button>
            </ImgAndButtonWrapper>
            <ImgAndButtonWrapper>
                <SmallImg src={smartManufacturingConfig[cardContent][langCh?'ch':'en'].smallImg[3]}/>
                <Button onClick={()=>setCardContent('SMSmartService')}>
                    {langCh? '智慧服務' : 'Smart Service'}
                </Button>
            </ImgAndButtonWrapper>
        </ImgsAndButtonsWrapper>
        <div 
            style={{position:onPlay?'absolute':'relative',
                    marginBottom:'10px',
                    zIndex:'200',
                    marginTop:'15px'}}
            >
                <ReactPlayer 
                    ref={playerRef}
                    url={smartManufacturingConfig[cardContent][langCh?'ch':'en'].videoUrl}
                    width={onPlay?contentRef.current.clientWidth:'30vw'}
                    height={onPlay?contentRef.current.clientHeight:'17vw'}
                    style={{minWidth:'250px',minHeight:'140px'}}
                    light={false}
                    onPlay={()=>{setOnPlay(true)}}
                    onPause={()=>{setOnPlay(false)}}
                />
        </div>
    </>
    )
}

const SMSmartAutomation=(props)=>{
    
    const{langCh,cardContent,setCardContent}=props

return(
    <>
        <GoBackAndBtnWrapper>
            <GoBackBtn 
                onClick={()=>{setCardContent('SMObjectives')}}
                style={{marginLeft: '5%'}}
            >  
                <p>{langCh?'<< 智慧智造目的':'<< Smart Manufacturing Objectives'}</p>
            </GoBackBtn>
            {smartManufacturingConfig[cardContent][langCh?'ch':'en'].videoUrl&&
            <Button
                onClick={(e) => {e.preventDefault();
                    window.open(smartManufacturingConfig[cardContent][langCh?'ch':'en'].videoUrl, '_blank');
                }}
                style={{marginRight:'5%'}}
            >
                <ButtonIcon src={videoIcon}/>
                {langCh?'產品影片':'Video'}
            </Button>
            }
        </GoBackAndBtnWrapper>
        <Img src={smartManufacturingConfig[cardContent][langCh?'ch':'en'].img0} />
        <Img src={smartManufacturingConfig[cardContent][langCh?'ch':'en'].img1} />
    </>
    )
}


const SMSmartMachines =(props)=>{
    
    const{langCh,cardContent,setCardContent}=props

    return(
    <>
        <GoBackAndBtnWrapper>
            <GoBackBtn 
                onClick={()=>{setCardContent('SMObjectives')}}
                style={{marginLeft: '5%'}}
            >  
                <p>{langCh?'<< 智慧智造目的':'<< Smart Manufacturing Objectives'}</p>
            </GoBackBtn>
            <ButtonWrapper>
                {smartManufacturingConfig[cardContent][langCh?'ch':'en'].demoUrl &&
                <Button
                    onClick={(e) => {e.preventDefault();
                        window.open(smartManufacturingConfig[cardContent][langCh?'ch':'en'].demoUrl, '_blank');
                    }}
                >
                    <ButtonIcon src={onlineDemoIcon}/>
                    {langCh?'線上型錄':'Brochure'}
                </Button>
                }
                {smartManufacturingConfig[cardContent][langCh?'ch':'en'].videoUrl &&
                <Button
                    onClick={(e) => {e.preventDefault();
                        window.open(smartManufacturingConfig[cardContent][langCh?'ch':'en'].videoUrl, '_blank');
                    }}
                    style={{marginRight:'5%'}}
                >
                    <ButtonIcon src={videoIcon}/>
                    {langCh?'產品影片':'Video'}
                </Button>
                }
            </ButtonWrapper>
        </GoBackAndBtnWrapper>
        <Img src={smartManufacturingConfig[cardContent][langCh?'ch':'en'].img}/>
    </>
    )
}


const SMSmartManagement=(props)=>{
    
    const{langCh,cardContent,setCardContent}=props

    return(
    <>
        <GoBackAndBtnWrapper>
            <GoBackBtn 
                onClick={()=>{setCardContent('SMObjectives')}}
                style={{marginLeft: '5%'}}
            >  
                <p>{langCh?'<< 智慧智造目的':'<< Smart Manufacturing Objectives'}</p>
            </GoBackBtn>
            <ButtonWrapper>
                {smartManufacturingConfig[cardContent][langCh?'ch':'en'].demoUrl &&
                <Button
                    onClick={(e) => {e.preventDefault();
                        window.open(smartManufacturingConfig[cardContent][langCh?'ch':'en'].demoUrl, '_blank');
                    }}
                >
                    <ButtonIcon src={onlineDemoIcon}/>
                    {langCh?'線上型錄':'Brochure'}
                </Button>
                }
                {smartManufacturingConfig[cardContent][langCh?'ch':'en'].videoUrl &&
                <Button
                    onClick={(e) => {e.preventDefault();
                        window.open(smartManufacturingConfig[cardContent][langCh?'ch':'en'].videoUrl, '_blank');
                    }}
                    style={{marginRight:'5%'}}
                >
                    <ButtonIcon src={videoIcon}/>
                    {langCh?'產品影片':'Video'}
                </Button>
                }
            </ButtonWrapper>
        </GoBackAndBtnWrapper>
        <Img src={smartManufacturingConfig[cardContent][langCh?'ch':'en'].img}/>
    </>
    )
}

const SMSmartService=(props)=>{
    
    const{langCh,cardContent,setCardContent}=props

    return(
    <>
        <GoBackAndBtnWrapper>
            <GoBackBtn 
                onClick={()=>{setCardContent('SMObjectives')}}
                style={{marginLeft: '5%'}}
            >  
                <p>{langCh?'<< 智慧智造目的':'<< Smart Manufacturing Objectives'}</p>
            </GoBackBtn>
            <ButtonWrapper>
                {smartManufacturingConfig[cardContent][langCh?'ch':'en'].demoUrl &&
                <Button
                    onClick={(e) => {e.preventDefault();
                        window.open(smartManufacturingConfig[cardContent][langCh?'ch':'en'].demoUrl, '_blank');
                    }}
                >
                    <ButtonIcon src={onlineDemoIcon}/>
                    {langCh?'線上型錄':'Brochure'}
                </Button>
                }
                {smartManufacturingConfig[cardContent][langCh?'ch':'en'].videoUrl &&
                <Button
                    onClick={(e) => {e.preventDefault();
                        window.open(smartManufacturingConfig[cardContent][langCh?'ch':'en'].videoUrl, '_blank');
                    }}
                    style={{marginRight:'5%'}}
                >
                    <ButtonIcon src={videoIcon}/>
                    {langCh?'產品影片':'Video'}
                </Button>
                }
            </ButtonWrapper>
        </GoBackAndBtnWrapper>
        <Img src={smartManufacturingConfig[cardContent][langCh?'ch':'en'].img0} />
        <Img src={smartManufacturingConfig[cardContent][langCh?'ch':'en'].img1} />
    </>
    )
}

export {SMObjectives, SMSmartAutomation, SMSmartMachines, SMSmartManagement, SMSmartService}